/**
 * Whether an MCP server config is usable for connection: at least one tool must
 * be granted by an admin (`AUTO`). Used by the MCP connections sidepanel and
 * Tenant Admin MCP status to stay aligned on when live pings are appropriate.
 */
export function mcpAdminHasGrantedAtLeastOneTool(
  toolPermissions: ReadonlyArray<{permission: string}>
): boolean {
  return toolPermissions.some((p) => p.permission === 'AUTO');
}
